<template>
  <VaSidebar v-model="writableVisible" :width="sidebarWidth" :color="color" :hoverable="false" minimized-width="0">
    <div class="side-header bg-blue-50 px-5 pt-4 pb-5">
      <img src="/public/transrafael_logo.png" alt="Logo" />
    </div>

    <div class="flex w-full mt-2 gap-2 justify-center content-center items-center px-5">
      <div class="w-full">
        <VaButtonDropdown
          :model-value="showDropdown"
          class="mr-2 mb-2 w-full text-xxs button-full"
          size="small"
          split
          :is-content-hoverable="true"
          label="Acciones rapidas"
          background-opacity="2"
          @mainButtonClick="() => (showDropdown = !showDropdown)"
        >
          <p
            class="px-1 py-0.5 text-xxs hover:underline text-primary cursor-pointer font-semibold"
            @click="
              () => {
                toggleQuotation()
              }
            "
          >
            (F6) - Nueva Cotizacion
          </p>
          <p
            class="px-1 py-0.5 text-xxs hover:underline text-primary cursor-pointer font-semibold"
            @click="
              () => {
                toggleContact()
              }
            "
          >
            (F7) - Nuevo Cliente
          </p>
          <p
            class="px-1 py-0.5 text-xxs hover:underline text-primary cursor-pointer font-semibold"
            @click="
              () => {
                toggleCompany()
              }
            "
          >
            (F8) - Nueva Empresa
          </p>
          <p
            class="px-1 py-0.5 text-xxs hover:underline text-primary cursor-pointer font-semibold"
            @click="
              () => {
                toggleContract()
              }
            "
          >
            (F9) - Nuevo Contrato
          </p>
        </VaButtonDropdown>
        <!-- OVERLAY -->
        <!-- <div class="w-full h-full top-0 left-0 bg-black fixed"></div> -->
      </div>
      <div class="text-end">
        <!-- <VaIcon class="cursor-pointer -mt-2.5" name="tab_search" size="medium" /> -->
      </div>
    </div>

    <VaAccordion v-model="value" multiple>
      <div v-for="(module, _index) in navigationRoutes.modules" :key="_index">
        <h3 v-if="module.name" class="py-1.5 font-bold text-xs px-4 bg-black bg-opacity-10">{{ module.name }}</h3>
        <VaCollapse v-for="(route, index) in module.routes" :key="index">
          <template #header="{ value: isCollapsed }">
            <VaSidebarItem
              :to="route.children ? undefined : { name: route.name }"
              :active="routeHasActiveChild(route)"
              :active-color="activeColor"
              :text-color="textColor(route)"
              :aria-label="`${route.children ? 'Open category ' : 'Visit'} ${t(route.displayName)}`"
              role="button"
              hover-opacity="0.10"
              :disabled="route.disabled"
              @click="route.children ? undefined : showLoading(route.name)"
            >
              <VaSidebarItemContent class="py-1.5 pr-2 pl-4">
                <VaIcon
                  v-if="route.meta.icon"
                  aria-hidden="true"
                  :name="route.meta.icon"
                  size="18.5px"
                  class="material-symbols-outlined"
                  :color="iconColor(route)"
                />
                <VaSidebarItemTitle class="flex justify-between items-center text-xs font-semibold leading-3">
                  {{ t(route.displayName) }}
                  <VaIcon v-if="route.children" :name="arrowDirection(isCollapsed)" size="13px" />
                </VaSidebarItemTitle>

                <VaChip v-if="route.disabled" class="text-xxs px-0" color="danger">
                  <VaIcon size="10px" name="error" />
                </VaChip>
              </VaSidebarItemContent>
            </VaSidebarItem>
          </template>
          <template #body>
            <div v-for="(childRoute, index2) in route.children" :key="index2">
              <VaSidebarItem
                :to="{ name: childRoute.name }"
                :active="isActiveChildRoute(childRoute)"
                :active-color="activeColor"
                :text-color="textColor(childRoute)"
                :aria-label="`Visit ${t(route.displayName)}`"
                hover-opacity="0.10"
                @click="showLoading(childRoute.name)"
              >
                <VaSidebarItemContent class="py-1 pr-2 pl-11">
                  <VaSidebarItemTitle class="leading-1 font-semibold text-xs">
                    {{ t(childRoute.displayName) }}
                  </VaSidebarItemTitle>
                </VaSidebarItemContent>
              </VaSidebarItem>
            </div>
          </template>
        </VaCollapse>
      </div>
    </VaAccordion>

    <VaSpacer />

    <div class="side-user-card px-5 flex gap-1 mt-3 relative">
      <VaAvatar
        class="-ml-1 mr-1"
        size="small"
        src="https://i.pinimg.com/564x/ef/8d/18/ef8d187e3af94c1ec0d200ea4d97217f.jpg"
      />
      <div class="cursor-pointer max-w-[150px]" @click="showProfile">
        <h4 class="text-xs font-bold capitalize">{{ username }}</h4>
        <p>Administrador</p>
      </div>
      <VaIcon
        name="logout"
        size="16px"
        class="material-symbols-outlined ml-2 cursor-pointer absolute right-3 top-2"
        @click="doLogout"
      />
    </div>

    <hr class="mt-5" />

    <VaAccordion v-if="userStore.can_edit">
      <VaSidebarItem to="/settings">
        <VaSidebarItemContent>
          <VaIcon name="settings" size="20px" class="material-symbols-outlined" />
          <VaSidebarItemTitle class="flex justify-between items-center text-xs font-semibold">
            Configuración
          </VaSidebarItemTitle>
        </VaSidebarItemContent>
      </VaSidebarItem>
    </VaAccordion>
  </VaSidebar>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useI18n } from 'vue-i18n'
import { useColors, useToast } from 'vuestic-ui'

import navigationRoutes, { type INavigationRoute } from './NavigationRoutes'
import { useUserStore } from '../../stores/user-store'
import { useGlobalStore } from '../../stores/global-store'

export default defineComponent({
  name: 'Sidebar',
  components: {},
  props: {
    visible: { type: Boolean, default: true },
    mobile: { type: Boolean, default: false },
  },
  emits: ['update:visible', 'show'],
  setup: (props, { emit }) => {
    const { getColor, colorToRgba } = useColors()
    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()
    const { notify } = useToast()
    const userStore = useUserStore()
    const { toggleQuotation, toggleCompany, toggleContract, toggleContact } = useGlobalStore()

    const showNewOportunity = ref(false)
    const showDropdown = ref(false)

    const value = ref<boolean[]>([])

    const writableVisible = computed({
      get: () => props.visible,
      set: (v: boolean) => emit('update:visible', v),
    })

    const showLoading = (path: any) => {
      console.log(path, route.path)
    }

    const showProfile = () => {
      emit('show', true)
    }

    const isActiveChildRoute = (child: INavigationRoute) => route.name === child.name

    const routeHasActiveChild = (section: INavigationRoute) => {
      if (!section.children) {
        return route.name === section.name
      }

      return section.children.some(({ name }) => route.path.endsWith(`${name}`))
    }

    // const setActiveExpand = () =>
    //   (value.value = navigationRoutes.routes.map((route: INavigationRoute) => routeHasActiveChild(route)))

    const sidebarWidth = computed(() => (props.mobile ? '100vw' : '220px'))
    const color = computed(() => getColor('background-secondary'))
    const username = computed(() => userStore.name)
    const activeColor = computed(() => colorToRgba(getColor('focus'), 0.1))

    const iconColor = (route: INavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'secondary')
    const textColor = (route: INavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'textPrimary')
    const arrowDirection = (state: boolean) => (state ? 'va-arrow-up' : 'va-arrow-down')

    const doLogout = () => {
      localStorage.clear()
      notify({ message: 'Cerraste sesión', color: 'info' })
      router.push('/auth').then(() => window.location.reload())
    }

    // watch(() => route.fullPath, setActiveExpand, { immediate: true })

    return {
      writableVisible,
      sidebarWidth,
      value,
      color,
      activeColor,
      navigationRoutes,
      username,
      userStore,
      routeHasActiveChild,
      isActiveChildRoute,
      t,
      iconColor,
      textColor,
      arrowDirection,
      doLogout,
      showProfile,
      showLoading,
      showNewOportunity,
      toggleQuotation,
      toggleCompany,
      toggleContract,
      toggleContact,
      showDropdown,
    }
  },
  mounted: () => {
    const { toggleQuotation, toggleCompany, toggleContract, toggleContact } = useGlobalStore()

    const handleKeyPress = (event: any) => {
      if (event.code === 'F6') {
        event.preventDefault()
        toggleQuotation()
      }

      if (event.code === 'F7') {
        event.preventDefault()
        toggleContact()
      }

      if (event.code === 'F8') {
        event.preventDefault()
        toggleCompany()
      }

      if (event.code === 'F9') {
        event.preventDefault()
        toggleContract()
      }
    }

    window.addEventListener('keydown', handleKeyPress)
  },
  methods: {},
})
</script>
